import { NOCS_PAGE_SIZE_DEFAULT, PARTICIPANTS_PAGE_SIZE_DEFAULT } from "@seagames/contracts";
import { z } from "zod";
import { idParam, pageParam, sizeParam } from "./list-params";

/** `/nocs?page&size` — a games has tens of NOCs, so one page normally holds them all. */
export const nocsSearch = z.object({ page: pageParam, size: sizeParam });
export type NocsSearch = z.infer<typeof nocsSearch>;

export const nocsPaging = (s: NocsSearch) => ({ page: s.page ?? 1, pageSize: s.size ?? NOCS_PAGE_SIZE_DEFAULT });

/** The NOC page's three sections. "sports" is the default and stays out of the URL. */
export const NOC_TABS = ["sports", "entries", "medals"] as const;
export type NocTab = (typeof NOC_TABS)[number];

/**
 * `/nocs/:id?games&tab&page&size` — `page` / `size` page the Entries tab
 * (the Medals tab is a keyset list: "Next 50", nothing in the URL).
 */
export const nocSearch = z.object({
	games: idParam,
	tab: z.enum(NOC_TABS).optional().catch(undefined),
	page: pageParam,
	size: sizeParam,
});
export type NocSearch = z.infer<typeof nocSearch>;

export const nocTabOf = (s: NocSearch): NocTab => s.tab ?? "sports";

export const nocEntriesPaging = (s: NocSearch) => ({ page: s.page ?? 1, pageSize: s.size ?? PARTICIPANTS_PAGE_SIZE_DEFAULT });

/** Another tab: its own paging starts over. */
export function nocSearchForTab(s: NocSearch, tab: NocTab): NocSearch {
	return { games: s.games, tab: tab === "sports" ? undefined : tab };
}
